import {Box, ImageProps} from "@chakra-ui/react";
import RawNextImage, {StaticImageData} from "next/image";

export type NextImageProps = {src: StaticImageData; fill?: boolean} & Omit<ImageProps, "src">;

const NextImage = ({src, style, fill, alt, ...props}: NextImageProps) => (
  <Box overflow="hidden" {...props}>
    <RawNextImage src={src} alt={alt ?? ""} fill={fill} style={style} />
  </Box>
);

export default NextImage;
